import { Radio,AppRouter } from '../vendor'

import DashboardController from './controllers/DashboardController'
import OrdersController from './controllers/OrdersController'
import ContingentsController from './controllers/ContingentsController'
import UsersController from './controllers/UsersController'
import AppointmentsController from './controllers/AppointmentsController'
import PricediscountsController from './controllers/PricediscountsController'
import PricetariffsController from './controllers/PricetariffsController'
import MyInboomaController from './controllers/MyInboomaController'
import VouchersController from './controllers/VouchersController'
import FinancesController from './controllers/FinancesController'
import ReservationsListController from './controllers/ReservationsListController'
import ReactWrapperController from './react/integration/ReactWrapperController'

import InboomaBaseView from './views/InboomaBaseView'

// Looooads of dependencies
import Contingents from './collections/Contingents'
import Resourcetypes from './collections/Resourcetypes'
import Locations from './collections/Locations'
import LocationsWithThrashed from './collections/LocationsWithTrashed'
import Pricetypes from './collections/Pricetypes'
import Pricetariffs from './collections/Pricetariffs'
import Pricediscounts from './collections/Pricediscounts'
import Products from './collections/Products'
import Orders from './collections/Orders'
import Users from './collections/Users'
import PaymentAccounts from './collections/PaymentAccounts'
import Wallets from './collections/Wallets'
import Networks from './collections/Networks'
//import Transactions from './collections/Transactions'
import Facilities from './collections/Facilities'
import Appointments from './collections/Appointments'
import Calendars from './collections/Calendars'
//import Vouchers from "./collections/Vouchers"
import VoucherTypes from "./collections/VoucherTypes"
import Reservations from './collections/Reservations'
import SalesBillings from './collections/SalesBillings'
import ReservationsList from './collections/ReservationsList';
import { Biscuit } from './utils'
import { getInitialView } from './utils/ViewSettings';
import { Backbone } from '../vendor';
import Inboomai18n from './utils/Inboomai18n';
import { getApiHost} from './Sync';

const InboomaAppRouter = AppRouter.extend({

  _previousControllerName : null,
  _previousControllerMethod : null,
  _controllerHistory : {
    currentController : {},       // currently called controller
    previousController : {},      // previously called controller
    beforePrevCtrl : {}           // controller called before previous controller
  },

  execute (callback, args, methodName) {

    // check if token is still valid
    const AuthorizationRequest = Backbone.Model.extend({
      urlRoot: '/orders?limit=1'
    });

    (new AuthorizationRequest()).fetch({
        success (model, response) {
            //console.log("SUCC");    // do nothing
        },
        error (model,response) {
          if (response.status == 401) {       // unauthorized (every user is allowed to display order list except session has been expired)
            // token invalid
            const host = getApiHost();
            const url =  btoa(encodeURI(window.location.href));
            let target = "";
            let query = "";

            if (host.indexOf('test') >= 0) target = 'https://test-web.inbooma.net/login.html';
            else if (host.indexOf('staging') >= 0) target = 'https://staging-web.inbooma.net/login.html';
            else target = 'https://web.inbooma.net/login.html';

            if(url != ""){
              query = "?query=" + url;
            }

            alert(Inboomai18n.translate('session_expired'));

            document.location.href = target + query;
          }
        }
    });

      // @override Backbone.Router.prototype.execute
      // == onBeforeCallRoute 
      const that = this,
            appChannel = Radio.channel('app'),
            controllerName = this.controller._channelName;

      // Inform window about route changes
      appChannel.trigger(
          'router:execute', 
          {
              'controllerName' : this._previousControllerName,
              'controllerMethod' : this._previousControllerMethod
          },
          {
              'controllerName' : controllerName,
              'controllerMethod' : methodName
          }
      );
      if (this._previousControllerName === null
       || typeof this.controller._modalViewMethods === 'undefined'
       || typeof this.controller._modalViewMethods[methodName] === 'undefined') {
          // Use _modalViewMethods in controller to specify modals
          // not requiring whole page re-render
          this.controller.setLayout(
              this.controller._template,
              this.controller._templateContext()
          );
      }

      this._updateControllerHistory(controllerName,methodName);         // store navigation history / recently called controller

      this._previousControllerName = controllerName;
      this._previousControllerMethod = methodName;

      this.controller.loadDependencies(this.dependencies)
                     .then(function() {
        
          // Remove all classes from body
          const bodyClassList = document.body.classList;

          while (bodyClassList.length > 0) {
              bodyClassList.remove(bodyClassList.item(0));
          }

          if (callback) {
              callback.apply(that, args);

              if (methodName === 'index') {
                  methodName = controllerName;
              } else {
                  // Always keep controller-class
                  document.body.classList.add('view-' + controllerName);
              }

              document.body.classList.add('view-' + methodName);

              document.title = 'Inbooma Web | ' + InboomaBaseView.prototype.t(methodName,null,'capital')
              // Set sub bar link to active
              if (typeof that.controller._accessBarMap !== 'undefined') {

                if (typeof that.controller.accessBar.options.linksMap[methodName] !== 'undefined') {
                    that.controller.accessBar.changeActiveLink(methodName);
                }
              }
              
          }
    })
  },

  /* update navigation history of controller - controller can listen to channel and update own history
   * this is useful for controllers to know which controller has been called previously
   * this has been implemented because this._previousControllerName is sometimes wrong because of cashed values
  */
  _updateControllerHistory (controllerName, controllerMethod) {

    this._controllerHistory.beforePrevCtrl = this._controllerHistory.previousController;
    this._controllerHistory.previousController = this._controllerHistory.currentController;
    this._controllerHistory.currentController = { 'name' : controllerName, 'method' : controllerMethod };

    var channel = Radio.channel('app');

    channel.trigger(
      'router:history',
      {
        'currentController' : this._controllerHistory.currentController,
        'previousController' : this._controllerHistory.previousController,
        'beforePrevController' : this._controllerHistory.beforePrevController
      }
    );
  }
});

const getReactInitialRoute = () => {

  const initView = getInitialView();
  switch (initView) {
    case 'tasks':
      return 'taskIndex';
    case 'resources':
      return 'resourcesIndex';
   // case 'reservationsList':
    //  return 'reservationsIndex';
    default:
      return 'dashboardIndex';
  }
};

const ReactRouter = InboomaAppRouter.extend({

    controller: new ReactWrapperController(),

    /* You won't need any dependencies except
       when using the demoPage:
    dependencies : {
        'orders' : new Orders()
    },*/
/*
    appRoutes : getInitialView() === "tasks" ? {
        'filemanager' : 'fileManagerIndex',
        'check_in_periods' : 'openingTimesIndex',
        'check_in_periods/:uri_params' : 'openingTimesIndex',
        '' : 'taskIndex',
        'tasks' : 'taskIndex',
        'tasks/:id' : 'taskIndex',
        'tasks/add' : 'taskIndex',
        'facilities' : 'facilityIndex',
        'facilities/:id' : 'facilityIndex',
        'facilities/add' : 'facilityIndex',
        'products' : 'productsIndex',
        'products/:id' : 'productsIndex',
        'products/add' : 'productsIndex',
        'resources' : 'resourcesIndex',
        'resources/:id' : 'resourcesIndex',
        'resources/add' : 'resourcesIndex',
        'pricetariffs' : 'pricetariffsIndex',
        'pricetariffs/:id' : 'pricetariffsIndex',
        'pricetariffs/:id/validFrom/:validFromId' : 'pricetariffsIndex',
        'pricetariffs/:id/validFrom/add' : 'pricetariffsIndex',
        'pricetariffs/:id/validFrom/:validFromId/returnTo/:productId' : 'pricetariffsIndex',
        'pricetariffs/:id/validFrom/add/returnTo/:productId' : 'pricetariffsIndex',
        'pricetariffs/:id/returnTo/:productId' : 'pricetariffsIndex',
        'pricetariffs/add/returnTo/:productId' : 'pricetariffsIndex',
        'pricetariffs/add' : 'pricetariffsIndex',
        'users' : 'usersIndex',
        'users/staff' : 'usersIndex',
        'users/:id' : 'usersIndex',
        'users/add' : 'usersIndex', 
        'usersExtension' : 'usersIndex',
        'users/help' : 'usersIndex',
        'usersExtension/:id' : 'usersIndex',
        'usersExtension/mailSettings': 'usersIndex',
        'dashboard_v2' : 'dashboardIndex'
    } : {
        'filemanager' : 'fileManagerIndex',
        'check_in_periods' : 'openingTimesIndex',
        'check_in_periods/:uri_params' : 'openingTimesIndex',
        'tasks' : 'taskIndex',
        'tasks/:id' : 'taskIndex',
        'tasks/add' : 'taskIndex',
        'facilities' : 'facilityIndex',
        'facilities/:id' : 'facilityIndex',
        'facilities/add' : 'facilityIndex',
        'products' : 'productsIndex',
        'products/:id' : 'productsIndex',
        'products/add' : 'productsIndex',
        'resources' : 'resourcesIndex',
        'resources/:id' : 'resourcesIndex',
        'resources/add' : 'resourcesIndex',
        'pricetariffs' : 'pricetariffsIndex',
        'pricetariffs/:id' : 'pricetariffsIndex',
        'pricetariffs/:id/validFrom/:validFromId' : 'pricetariffsIndex',
        'pricetariffs/:id/validFrom/add' : 'pricetariffsIndex',
        'pricetariffs/:id/validFrom/:validFromId/returnTo/:productId' : 'pricetariffsIndex',
        'pricetariffs/:id/validFrom/add/returnTo/:productId' : 'pricetariffsIndex',
        'pricetariffs/:id/returnTo/:productId' : 'pricetariffsIndex',
        'pricetariffs/add/returnTo/:productId' : 'pricetariffsIndex',
        'pricetariffs/add' : 'pricetariffsIndex',
        'users' : 'usersIndex',
        'users/staff' : 'usersIndex',
        'users/:id' : 'usersIndex',
        'users/add' : 'usersIndex', 
        'usersExtension' : 'usersIndex',
        'usersExtension/:id' : 'usersIndex',
        'usersExtension/mailSettings': 'usersIndex',
        'frontend_locations' : 'frontendLocationsIndex',
        'frontend_locations/:id' : 'frontendLocationsIndex',
        'frontend_locations/jobs' : 'frontendLocationsIndex',
        'dashboard_v2' : 'dashboardIndex'
    }
    */
    appRoutes : {
      'errors' : 'errorsIndex',
      'apperrors' : 'errorsIndex',
      'filemanager' : 'fileManagerIndex',
      'check_in_periods' : 'openingTimesIndex',
      'check_in_periods/:uri_params' : 'openingTimesIndex',
      '' : getReactInitialRoute(),
      'dashboard' : 'dashboardIndex',
      'tasks' : 'taskIndex',
      'tasks/:id' : 'taskIndex',
      'tasks/add' : 'taskIndex',
      'facilities' : 'facilityIndex',
      'facilities/:id' : 'facilityIndex',
      'facilities/add' : 'facilityIndex',
      'facilities/:id/:id' : 'facilityIndex',
      'facilities/:id/add' : 'facilityIndex',
      'products' : 'productsIndex',
      'products/:id' : 'productsIndex',
      'products/add' : 'productsIndex',
      'resources' : 'resourcesIndex',
      'resources/:id' : 'resourcesIndex',
      'resources/add' : 'resourcesIndex',
      'pricetariffs' : 'pricetariffsIndex',
      'pricetariffs/:id' : 'pricetariffsIndex',
      'pricetariffs/:id/validFrom/:validFromId' : 'pricetariffsIndex',
      'pricetariffs/:id/validFrom/add' : 'pricetariffsIndex',
      'pricetariffs/:id/validFrom/:validFromId/returnTo/:productId' : 'pricetariffsIndex',
      'pricetariffs/:id/validFrom/add/returnTo/:productId' : 'pricetariffsIndex',
      'pricetariffs/:id/returnTo/:productId' : 'pricetariffsIndex',
      'pricetariffs/add/returnTo/:productId' : 'pricetariffsIndex',
      'pricetariffs/add' : 'pricetariffsIndex',
      'contingents' : 'contingentsIndex',
      'contingents/:id' : 'contingentsIndex',
      'contingents/:id/ics' : 'contingentsIndex',
      'contingents/:id/pricetariffs' : 'contingentsIndex',
      'contingents/:id/resources/add' : 'contingentsIndex',
      'contingents/:id/resources/:resourceid/duplicate' : 'contingentsIndex',
      'contingents/:id/resources/:resourceid' : 'contingentsIndex',
      //'contingents/:id/:action' : 'contingentsIndex',
      'users' : 'usersIndex',
      'users/staff' : 'usersIndex',
      'users/:id' : 'usersIndex',
      'users/add' : 'usersIndex', 
      'usersExtension' : 'usersIndex',
      'users/help' : 'usersIndex',
      'usersExtension/:id' : 'usersIndex',
      'usersExtension/mailSettings': 'usersIndex',
      'mailSettings': 'usersIndex',
      'usersExtension/userGroups': 'usersIndex',
      'usersExtension/userGroups/:id': 'usersIndex',
      'usersExtension/userGroups/add': 'usersIndex',
      'usersExtension/userGroups/delete/:id': 'usersIndex',
      'usersExtension/messages' : 'usersIndex',
      'usersExtension/messages/add' : 'usersIndex',
      'usersExtension/messages/:id' : 'usersIndex',
      'usersExtension/messages/:id/view' : 'usersIndex',
      'usersExtension/userGroups/:id/listUsers': 'usersIndex',
      'frontend_locations' : 'frontendLocationsIndex',
      'frontend_locations/:id' : 'frontendLocationsIndex',
      'frontend_locations/jobs' : 'frontendLocationsIndex',
      'locations' : 'locationsIndex',
      'locations/:id' : 'locationsIndex',
      'locations/add' : 'locationsIndex',
      'finances' : 'financesIndex',
      'finances/sales_billings' : 'financesIndex',
      'finances/sales_billings/add' : 'financesIndex',
      'finances/sales_billings/:id' : 'financesIndex',
      'finances/insurances' : 'financesIndex',
      'finances/transactions' : 'financesIndex',
      'finances/transactions/openOrder/:id' : 'financesIndex',
      'finances/admin_transactions' : 'financesIndex',
      'finances/admin_transactions/openOrder/:id' : 'financesIndex',
      'finances/payment_accounts' : 'financesIndex',
      'finances/payment_accounts/paymentAccountForm/:id' : 'financesIndex',
      'finances/payment_accounts/paymentAccountForm' : 'financesIndex',
      'finances/payoutForm' : 'financesIndex',
      'statistics': 'statisticsIndex',
      'statistics/charts': 'statisticsIndex',
      'statistics/heatmap': 'statisticsIndex',
      'reservations/reservationsList': 'reservationsIndex',
      'reservations/orders': 'reservationsIndex',
      'reservations/calendar' : 'reservationsIndex',
      'reservations/reservationsList/add' : 'reservationsIndex',
      'reservations/reservationsList/:id' : 'reservationsIndex',
      'reservations/orders/add' : 'reservationsIndex',
      'reservations/orders/:id' : 'reservationsIndex',
      'settings' : 'clientSettingsIndex',
      'my-inbooma': 'myInbooma',
      'visual_inspections': 'visualInspectionsIndex',
      'visual_inspections/add': 'visualInspectionsIndex',
      'visual_inspections/:id': 'visualInspectionsIndex',
      'visual_inspections/:id/item/add': 'visualInspectionsIndex',
      'visual_inspections/:id/item/:id': 'visualInspectionsIndex',
      'vouchers': 'vouchersIndex',
      'vouchers/gift-cards' : 'vouchersIndex',
      'vouchers/add' : 'vouchersIndex',
      'vouchers/:vid': 'vouchersIndex',
      'vouchers/export/:vId' : 'vouchersIndex',
      'availables' : 'availabilitiesIndex',
      'helpdesk': 'helpDeskIndex',
      'invoices': 'invoicesIndex',
      'abonnements': 'abonnementsIndex',
      'abonnements/add': 'abonnementsIndex',
      'abonnements/:id': 'abonnementsIndex',
      'client_docs': 'clientDocumentsIndex',
      'client_docs/add': 'clientDocumentsIndex',
      'client_docs/:id': 'clientDocumentsIndex',
      'help_messages': 'helpMessagesIndex',
      'help_messages/add': 'helpMessagesIndex',
      'help_messages/:id': 'helpMessagesIndex',
      'help_messages/:id/add': 'helpMessagesIndex',
      'help_messages/:id/:id': 'helpMessagesIndex',
      'reports': 'reportsIndex',
      'reports/add': 'reportsIndex'
  }
});

const ContingentsRouter = InboomaAppRouter.extend({
  
  controller : new ContingentsController(),

  dependencies : {
    'contingents' : new Contingents(),
    'locations' : new Locations(),
    'resourcetypes' : new Resourcetypes(),
    'pricetypes' : new Pricetypes(),
    'products' : new Products(),
    'pricetariffs' : new Pricetariffs(),
    'users' : new Users(), // Required for Behavior.OffCanvas
    'facilities' : new Facilities(), // Make scoped for facility context
  },

  appRoutes : {
   /* 'contingents' : 'index',
    'contingents/add' : 'contingentsForm',
    'contingents/help' : 'contingentsHelp',
    'contingents/:id' : 'index',*/

   /* 'contingents/:id/pricetariffs' : 'contingentPricetariffsForm',
    'contingents/:id/resources/add' : 'resourcesForm',
    'contingents/:id/resources/:resourceid/duplicate' : 'duplicateResource',
    'contingents/:id/resources/:resourceid' : 'resourcesForm',
    'contingents/:id/:action' : 'contingentsForm',*/
    //'locations' : 'locations',
    //'locations/add' : 'locationsAction',
    //'locations/:id/:action' : 'locationsAction',
    //'facilities' : 'facilitiesList',
    //'facilities/add' : 'facilitiesForm',
    //'facilities/help' : 'facilitiesHelp',
    //'facilities/:id' : 'facilitiesList',
    //'facilities/:id/slots/add' : 'slotsForm',
    //'facilities/:id/slots/:resourceid' : 'slotsForm',
    //'facilities/:id/:action' : 'facilitiesForm',
    'contingent_plans' : 'contingentPlans',
    'contingent_plans/form' : 'contingentPlansForm',
    'network_plans' : 'networkPlans',
    'network_plans/form' : 'networkPlansForm'
  }
});

const OrdersRouter = InboomaAppRouter.extend({

  controller : new OrdersController(),

  dependencies : {
    'orders' : new Orders(),
    'locations' : new Locations(),
    'locationsWithTrashed' : new LocationsWithThrashed(),
    'pricetariffs' : new Pricetariffs(),
    'products' : new Products(),
    'users' : {
      'class' : new Users(),
      'notForUserRole' : 'user' 
    },
    'salesBillings' : new SalesBillings()
  },

  appRoutes : getInitialView() === 'orders' ? {
    '' : 'index',
    'orders' : 'index',
    'orders/add' : 'ordersForm',
    'orders/add/:options' : 'ordersForm',
   // 'orders/calendar' : 'calendar',
  //  'reservations/calendar' : 'calendar',
    'orders/help' : 'ordersHelp',
    'orders/export' : 'ordersExport',
    'orders/groupList' : 'getGroupList',
    'orders/:orderId/checkin/:reseverationId' : 'checkinOut',
    'orders/:orderId/:filename/ics' : 'createIcs',
    'orders/:orderId/:action' : 'ordersForm',
    'orders/:orderId/:action/:reservationId' : 'ordersForm',
   // 'orders/:orderId' : 'index'
  } : {
    'orders' : 'index',
    'orders/add' : 'ordersForm',
    'orders/add/:options' : 'ordersForm',
    'orders/calendar' : 'calendar',
    'reservations/calendar' : 'calendar',
    'orders/help' : 'ordersHelp',
    'orders/export' : 'ordersExport',
    'orders/groupList' : 'getGroupList',
    'orders/:orderId/checkin/:reseverationId' : 'checkinOut',
    'orders/:orderId/:filename/ics' : 'createIcs',
    'orders/:orderId/:action' : 'ordersForm',
    'orders/:orderId/:action/:reservationId' : 'ordersForm',
    'orders/:orderId' : 'index'
  },
});

const ReservationsListRouter = InboomaAppRouter.extend({

  controller : new ReservationsListController(),

  dependencies : {
    'orders' : new Orders(),
    'contingents' : new Contingents(),
    'locations' : new Locations(),
    'locationsWithTrashed' : new LocationsWithThrashed(),
    'reservationsList' : new ReservationsList(),
    'pricetariffs' : new Pricetariffs(),
    'networks' : new Networks(),
    'users' : {
       'class' : new Users(),
       'notForUserRole' : 'user'
    },
  },

 /* appRoutes : Number(Biscuit.get('user.client_id')) === 19 ? {
    '' : 'index',
    'reservationsList' : 'index',
    'reservationsList/:reservationId/:action' : 'reservationsForm',
    'reservationsList/add' : 'ordersAdd'
  } : {
    'reservationsList' : 'index',
    'reservationsList/:reservationId/:action' : 'reservationsForm',
    'reservationsList/add' : 'ordersAdd'
  },*/

  appRoutes : {
    'reservationsList' : 'index',
    'reservationsList/:reservationId/:action' : 'reservationsForm',
    'reservationsList/add' : 'ordersAdd'
  }
});

// @todo Not yet transformed to InboomaAppRouter
const PricediscountsRouter = InboomaAppRouter.extend({

    controller : new PricediscountsController(),
    dependencies : {
        'pricediscounts' : new Pricediscounts(),
        'users' : new Users()
    },
    appRoutes : {
      'pricediscounts' : 'index',
      'pricediscounts/user_discount' : 'userDiscount',
      'pricediscounts/user_discount/:id' : 'userDiscount',
      'pricediscounts/client_discount' : 'clientDiscount',
      'pricediscounts/client_discount/:id' : 'clientDiscount',
      'pricediscounts/number_discount' : 'numberDiscount',
      'pricediscounts/number_discount/:id' : 'numberDiscount',
      'pricediscounts/help' : 'pricediscountsHelp',
      'pricediscounts/add/:type' : 'pricediscountsForm',
      'pricediscounts/clientDiscount/:id' : 'index',
      'pricediscounts/userDiscount/:id' : 'index',
      'pricediscounts/numberDiscount/:id' : 'index',
    }
});


/*const PricetariffsRouter = InboomaAppRouter.extend({
  controller : new PricetariffsController(),

  dependencies : {
    'contingents' : new Contingents(),
    'pricetypes' : new Pricetypes(),
    'products' : new Products(),
    'pricetariffs' : new Pricetariffs()
  },

  appRoutes : {
    'pricetariffs' : 'index',
    'pricetariffs/help' : 'pricetariffsHelp',
    'pricetariffs/:id' : 'pricetariffsForm',
  }
});*/


const AppointmentsRouter = InboomaAppRouter.extend({
  controller : new AppointmentsController(),

  dependencies : {
    'calendars' : new Calendars(),
    'contingents' : new Contingents(),
    'appointments' : new Appointments(),
    'pricetariffs' : new Pricetariffs(),
    'orders' : new Orders(),
    'users' : new Users()
  },

  // :cid = calendar_id
  // :eid = event_id
  // :oid = order_id
  // :rid = reservation_id
  // appointment_id as part of :options
  appRoutes : getInitialView() === "appointments" ? {
    '' : 'index',
    'appointments' : 'index',
    'appointments/calendars/add' : 'appointmentsCalendarForm',
    'appointments/calendars/:cid' : 'appointmentsCalendarForm',
    'appointments/:cid/event/add' : 'appointmentsForm',
    'appointments/:cid/event/:edit' : 'appointmentsForm',
    'appointments/:cid/event/:eid/block/:options' : 'block',
    'appointments/:cid/event/:eid/reschedule/:options' : 'reschedule',
    'appointments/:cid' : 'index',
    'appointments/ordersForm/:oid/:rid' : 'openOrdersForm'
  } : {
    'appointments' : 'index',
    'appointments/calendars/add' : 'appointmentsCalendarForm',
    'appointments/calendars/:cid' : 'appointmentsCalendarForm',
    'appointments/:cid/event/add' : 'appointmentsForm',
    'appointments/:cid/event/:edit' : 'appointmentsForm',
    'appointments/:cid/event/:eid/block/:options' : 'block',
    'appointments/:cid/event/:eid/reschedule/:options' : 'reschedule',
    'appointments/:cid' : 'index',
    'appointments/ordersForm/:oid/:rid' : 'openOrdersForm'
  }
});

/*const VouchersRouter = InboomaAppRouter.extend({
    controller : new VouchersController(),

    dependencies: {
        'voucherTypes' : new VoucherTypes(),
        'users' : new Users() // Required for OffCanvasBehavior
    },

    appRoutes: {
        'vouchers': 'index',
        'vouchers/gift-cards' : 'giftCards',
        'vouchers/add' : 'vouchersForm',
        'vouchers/:vid': 'vouchersForm',
        'vouchers/export/:vId' : 'vouchersExport',
    }
});*/

/*let DashboardRouter;
if(Number(Biscuit.get('user.client_id')) !== 49) {
   DashboardRouter = InboomaAppRouter.extend({
    controller: new DashboardController(),

    dependencies: {
      'locations': new Locations()
    },

    //appRoutes : Number(Biscuit.get('user.client_id')) === 19 ? {
    //  'dashboard' : 'index'
    //} : {
    //'' : 'index',
    //  'dashboard' : 'index',
    //}
    appRoutes: getInitialView() === 'dashboard' ? {
      '': 'index',
      'dashboard': 'index'
    } : {
      'dashboard': 'index'
    }
  });
} else {
  DashboardRouter = InboomaAppRouter.extend({
    controller: new ReactWrapperController(),

    //appRoutes : Number(Biscuit.get('user.client_id')) === 19 ? {
    //  'dashboard' : 'index'
    //} : {
    //'' : 'index',
    //  'dashboard' : 'index',
    //}
    appRoutes: getInitialView() === 'dashboard' ? {
      '' : getReactInitialRoute(),
      'dashboard' : 'dashboardIndex'
    } : {
      'dashboard': getReactInitialRoute()
    }
  });
}*/

const SalesBillingsRouter = InboomaAppRouter.extend({
  controller : new FinancesController(),

  dependencies: {
    'locations' : new Locations(), // Required for OffCanvasBehavior
    'users' : new Users(), // Required for OffCanvasBehavior
    'salesBillings' : new SalesBillings(),
    'wallets' : new Wallets(),
    //'transactions' : new Transactions(),
    'paymentAccounts' : new PaymentAccounts(),
    'orders' : new Orders(),
    'pricetariffs' : new Pricetariffs(),
  },

  appRoutes: {
    'finances_old' : 'index',
    'finances_old/sales_billings' : 'index',
    'finances_old/sales_billings/add' : 'salesBillingsForm',
    'finances_old/sales_billings/:id': 'salesBillingsForm',
    'finances_old/transactions' : 'transactions',
    'finances_old/transactions/openOrder/:id' : 'openOrdersForm',
    'finances_old/payment_accounts' : 'payment_accounts',
    // @todo Following two URI's are not ideal, maybe "form" would be enough
    'finances_old/payment_accounts/paymentAccountForm/:id' : 'paymentAccountForm',
    'finances_old/payment_accounts/paymentAccountForm' : 'paymentAccountForm',
    'finances_old/payoutForm' : 'payoutForm',
  }
});

const MyInboomaRouter = InboomaAppRouter.extend({
  controller : new MyInboomaController(),

  dependencies : {
    'users' : new Users(),
    'locations' : new Locations(),
  },
 
  appRoutes: {
    'client/ics' : 'createClientIcs',
//    'my-inbooma' : 'overview',
    //'prices-overview' : 'pricesOverview',
    '*notFound': 'notFoundError'
  }
});

  export default
  {
    MyInboomaRouter,
        OrdersRouter,
        ReservationsListRouter,
        ContingentsRouter,
        AppointmentsRouter,
        PricediscountsRouter,
        // PricetariffsRouter,
        //DashboardRouter,
       // VouchersRouter,
        SalesBillingsRouter,
        ReactRouter
  };

